import { useState } from 'react';
import { FiCopy } from 'react-icons/fi';

export default function EmbedCodeGenerator({ formId }) {
  const [copied, setCopied] = useState(false);
  
  const embedCode = `<!-- Form Embed Code -->
<iframe 
  src="${window.location.origin}/#/embed/${formId}"
  width="100%" 
  style="border: none; width: 100%; min-height: 200px;"
  scrolling="no"
></iframe>
<script src="${window.location.origin}/embed.js"></script>`;

  const handleCopy = () => {
    navigator.clipboard.writeText(embedCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <div className="flex justify-between items-center mb-2">
        <h3 className="font-semibold">Embed Code</h3>
        <button
          onClick={handleCopy}
          className="flex items-center text-sm text-blue-500 hover:text-blue-600"
        >
          <FiCopy className="mr-1" />
          {copied ? 'Copied!' : 'Copy Code'}
        </button>
      </div>
      <pre className="bg-gray-800 text-white p-4 rounded text-sm overflow-x-auto">
        {embedCode}
      </pre>
    </div>
  );
}